/* 
 * NOTICE OF LICENSE
 * 
 * This source file is subject to the Academic Free License (AFL 3.0)
 * 
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2019 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */


import $ from 'jquery';

( function() {
    
    var ww = $(window).width();
    if( ww <= 991 ){ return false; }

    var pages = $('.js-vertical-links a');
    var view = $('.js-whatWeOffer-slider');
    var current = 0;
    var max = $('.js-vertical-links li').length -1;
    var locked = true;

    function move(pos){
        pages.removeClass('active').eq(pos).addClass('active');
        view.animate({  view: (100*pos) }, {
            step: function(now) {
              $(this).css('transform','translate(0%, -' + now + '%)');  
            },
            complete: function (){
                if( current === max ){ locked = false; }
                if( current === 0 ){ locked = false; }
            },
            duration: 'slow'
        },'linear');
    }

    function scroll(k){
        if(k < 0){
            if(current >= max || view.is(':animated')){ return false; }
            current ++;
            move(current);
        }else{
            if(current <= 0 || view.is(':animated')){return  false;}
            current --;
            move(current);
        }
    }

    pages.on('click', function (e){
        e.preventDefault();
        if(view.is(':animated')){return  false;}
        current = $(this).parent('li').index();
        move(current);
    });

    $('.whatWeOfferSlider').bind('mousewheel DOMMouseScroll MozMousePixelScroll', function(e) {     // 3 event gia olous tous browsers
        if( locked ){
            e.preventDefault();
            var delta = e.originalEvent.wheelDelta || -e.originalEvent.detail;
            scroll(delta);
        }
    });
    

    $('.whatWeOfferSlider').hover(function () {
        locked = true;
    }, function () {
        locked = false;
    });

    
} )();